import { useContext } from 'react';
import { styled } from '@mui/material';
import { QChip, QTypography } from '@kw/quokka-ui';
import { PolicyInfoContext } from './PolicyInfoContext';

export const PolicyProfileHeader = () => {
  const { policyName, policyEnabled } = useContext(PolicyInfoContext);

  const chipProps = policyEnabled
    ? { label: 'Enabled', color: 'success', variant: 'filled' }
    : { label: 'Disabled', color: 'warning', variant: 'outlined' };

  return (
    <StyledHeaderText>
      {policyName}{' '}
      <QChip label={`${chipProps.label} Policy`} color={chipProps.color as any} variant={chipProps.variant as any} size="small" />
    </StyledHeaderText>
  );
};

const StyledHeaderText = styled(QTypography)`
  line-height: 45px;
  color: '${props => props.theme.palette.text.primary}';
  // shorten leading trim on leftside to offset default whitespace
  margin-left: -4px;
  flex-grow: 1;
` as typeof QTypography;

// @ts-ignore
StyledHeaderText.defaultProps = {
  component: 'h1',
  variant: 'h1Regular',
};
